import React from "react";
import { DefaultContextValue } from "@hex-insights/core";
import { PageInfo } from "@hex-insights/router";
import { MessageGroup, User } from "../../../../Utilities";

export type MessageSendingInformationContextValue = {
	viewerID: User["id"];
	messagingMessageGroupPageInfo: PageInfo<any, (id: MessageGroup["id"]) => string, any>;
};

export const MessageSendingInformationContext = React.createContext<MessageSendingInformationContextValue>(
	new DefaultContextValue("MessageSendingInformationContext") as any,
);
